<template>
    <el-dialog
    title="不动产经营租赁服务发票预览"
    width="80%"
    :visible.sync="visible"
    :append-to-body="true"
    top="2%"
    >
        <div class="previewInvoiceBox">
            <div class="invoicMain">
            <!-- head start -->
            <div class="invoiceHeader">
                <div class="headerLeft">
                    <div class="QRCodeBox flex-column-center">
                        <span>动态</span>
                        <span>二维码</span>
                    </div>
                    <div class="flex-center">
                        <p class="c"><label style="color: #000; font-weight: 400; font-size: 14px; margin-right: 10px; margin-left: 15px; white-space: nowrap;"
                                class="rmb">不动产经营租赁服务</label>
                        </p>
                    </div>
                </div>
                <div class="headerMiddle flex-column-center">
                    <h1>电子发票（增值税专用发票）</h1>
                    <div class="line"></div>
                </div>
                <div class="headerRight">
                    <p><label>发票号码：</label><span class="">{{ infoData.invoiceNo }}</span></p>
                    <p><label>开票日期：</label><span>{{ infoData.makeInvoiceDate }}</span></p>
                </div>
            </div>
            <!-- head end -->
            <!-- invoice body start -->
            <div class="invoiceBody">
                <div class="userInfo">
                    <div class="buy">购买方信息</div>
                    <ul class="headUl">
                        <li>
                            <label>名称：</label><span class="rmb">{{ infoData.buyerName }}</span>
                        </li>
                        <li>
                            <label>统一社会信用代码/纳税人识别号：</label><span style=" letter-spacing: 2px; font-size: 15px;"
                                class="fontFamilyAuto">{{ infoData.buyerTaxNo }}</span>
                        </li>
                        <!-- <li>
                            <label>地址、&nbsp;电话：</label><span class="f-small">济南市槐荫区经十路4214209号 0531-85094547</span>
                        </li>
                        <li>
                            <label>开户行及账号：</label><span class="f-small">中国银行股份有限公司济南大学科技园支行 6225885410839945</span>
                        </li> -->
                    </ul>
                    <div class="password vertical-rl">销售方信息</div>
                    <ul class="headUl" style="width: 100%;">
                        <li>
                            <label>名称：</label><span class="rmb">{{ infoData.sellerName }}</span>
                        </li>
                        <li>
                            <label>统一社会信用代码/纳税人识别号：</label><span style=" letter-spacing: 2px; font-size: 15px;"
                                class="fontFamilyAuto">{{ infoData.sellerTaxNo }}</span>
                        </li>
                    </ul>
                </div>
                <div>
                    <table class="GoodsTable" cellpadding="0" cellspacing="0">
                        <thead>
                            <tr >
                                <td style="width: 26%">项目名称</td>
                                <td style="width: 18%">产权证书/不动产权证号</td>
                                <td style="width: 8%">面积单位</td>
                                <td style="width: 14%">数&emsp;量</td>
                                <td style="width: 10%">单&emsp;价</td>
                                <td style="width: 13%">金&emsp;额</td>
                                <td style="width: 14%">税率/征收率</td>
                                <td style="width: 7%; border-right: none;">税&emsp;额</td>
                            </tr>
                        </thead>
                        <tbody class="invoice-list" style="height: 126px; ">
                            <tr class="fontFamilyAuto" v-for="(item,index) in infoData.invoiceDetails" :key="index">
                                <td><span>{{ item.projectName }}</span></td>
                                <td class="text-c"><span>{{ item.assetCertificate }}</span></td>
                                <td class="text-c"><span>{{ item.areaUnit }}</span></td>
                                <td class="text-c"><span>{{ item.quantity }}</span></td>
                                <td class="text-c"><span>{{ item.unitPrice }}</span></td>
                                <td class="text-c"><span>{{ item.fee }}</span></td>
                                <td class="text-c"><span>{{ item.taxRate }}</span></td>
                                <td><span>{{ item.taxAmt }}</span></td>
                            </tr>

                            <tr class="total"><td></td>
                                <td>&nbsp;</td>
                                <td></td></tr>
                            <tr class="total"><td></td>
                                <td>&nbsp;</td>
                                <td></td></tr>
                            <tr class="total"><td></td>
                                <td>&nbsp;</td>
                                <td></td></tr>
                            <tr class="total"><td></td>
                                <td></td>
                                <td></td></tr>
                            <tr class="total">
                                <td>合 &nbsp;&nbsp;&nbsp;计</td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td class="text-c"><span >￥</span>{{ feeSum }}</td>
                                <td></td>
                                <td><span class="">￥</span>{{ taxAmtSum }}</td>
                            </tr>

                        </tbody>

                        <tfoot>
                            <tr class="GoodsTotal" >
                                <td style="border-right: 1px solid #800000;">价税合计(大写)</td>
                                <td colspan="7">
                                    <div style="width: 100%;display:flex">
                                        <div type="text" style="width: 60%"><span class='c-black fontFamilyAuto'>ⓧ{{ numberToChineseUppercase(amtSum) }}</span></div>

                                        <div type="text" style="width: 30%"> (小写) <span class='c-black fontFamilyAuto'><span
                                                    class="rmb">￥</span>{{ amtSum }}</span></div>
                                    </div>

                                </td>
                            </tr>
                        </tfoot>
                    </table>
                    <div class="userInfo">
                        <div class="buy">备注</div>
                        <ul style="font-family: auto; color: #222;">
                            <li>
                                <span>不动产地址：</span>
                                <span>{{ infoData.invoiceContent && infoData.invoiceContent.length ? infoData.invoiceContent[0].realEstateAddress : ''}}; </span>&emsp;
                                <span>租赁期起止：</span>
                                <span>{{ infoData.invoiceContent && infoData.invoiceContent.length ? infoData.invoiceContent[0].rentStartDate : ''}}
                                    {{ infoData.invoiceContent && infoData.invoiceContent.length ? infoData.invoiceContent[0].rentEndDate : '' }}; </span>&emsp;
                                <span>跨地（市）标志：</span>
                                <span>
                                    {{  SRM_YES_NO[ infoData.invoiceContent && infoData.invoiceContent.length ? infoData.invoiceContent[0].crossCityFlag : '']  }};
                                </span>
                            </li>
                            <li v-if="infoData.ifShowBuyer" >
                                <span>购买方开户银行：</span><span>{{infoData.buyerBankName}}; </span>&emsp;
                                <span>银行账号：</span><span>{{infoData.buyerBankAccount}}; </span>
                            </li>
                            <li  v-if="infoData.ifShowSeller">
                                <span>销售方开户银行：</span><span>{{infoData.sellerBankName}}; </span>&emsp;
                                <span>银行账号：</span><span>{{infoData.sellerBankAccount}}; </span>
                            </li>
                            <li v-if="infoData.remark">
                                <span>{{infoData.remark}}; </span>
                            </li>
                            <li>
                                <span v-if="infoData.payee">收款人：</span><span v-if="infoData.payee">{{infoData.payee}}; </span>&emsp;&emsp;
                                <span v-if="infoData.checker">复核人：</span><span v-if="infoData.checker">{{infoData.checker}}; </span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <ul class="invoicetFooter">
                <li>
                    <label>开票人：</label><span style="font-family: auto; color: #222;">{{infoData.makeInvoiceOperator}}</span>
                </li>
            </ul>
        </div>
        </div>
    </el-dialog>
</template>

<script>
import { getDictAndOptions } from '@/modules/transport/bms/api/common.js';
import { numberToChineseUppercase } from './utils';
import { accAdd } from '@/utils/accuracyCalculation.js';

export default {
    props: {
        infoData: {
            type: Object
        }
    },
    data() {
        return {
            visible: false,
            feeSum: 0, // 不含税金额
            amtSum: 0, // 含税金额
            taxAmtSum: 0, // 税额
            BMS_TRANSPORT_TYPE: {},
            SRM_YES_NO: {},
            numberToChineseUppercase
        };
    },
    methods: {
        show() {
            this.visible = true;
        }
    },
    watch: {
        infoData: {
            immediate: true,
            handler(newValue, oldValue) {
                this.feeSum = 0;
                this.amtSum = 0;
                this.taxAmtSum = 0;
                newValue.invoiceDetails instanceof Array && newValue.invoiceDetails.forEach(el => {
                    this.feeSum = accAdd(el.fee, this.feeSum);
                    this.taxAmtSum = accAdd(el.taxAmt, this.taxAmtSum);
                    this.amtSum = accAdd(el.amt, this.amtSum);
                    el.unitPrice = el.fee && el.quantity ? Number(el.fee / el.quantity).toFixed(2) : '';
                });
            }
        }
    },
    async created() {
        const { BMS_TRANSPORT_TYPE, SRM_YES_NO } = await getDictAndOptions('BMS_TRANSPORT_TYPE,SRM_YES_NO');
        this.BMS_TRANSPORT_TYPE = BMS_TRANSPORT_TYPE;
        this.SRM_YES_NO = SRM_YES_NO;
    }
};
</script>

<style scoped>
        label {
            color: #800000;
        }

        .contentThead{
            display: flex;
            justify-content: space-around;
            align-items: center;
            height: 100%;
            width: 100vh;
        }

        .previewInvoiceBox{
            width: 100%;
            min-height: 50vh;
            background-color: #525659;
            display: flex;
            justify-content: center;
            align-items: center;
            font-family: cursive;
            padding: 50px 0;
        }

        .rmb {
            font-family: Arial, Helvetica, sans-serif;
        }

        .c-red {
            color: #ff3133;
        }

        .c-black {
            color: #000;
        }

        .f-big {
            font-size: 20px;
        }

        .f-small {
            font-size: 12px;
        }

        .f-small2 {
            font-size: 10px;
        }

        .invoicMain {
            width: 920px;
            margin: 0 auto;
            font-size: 12px;
            color: #000;
            padding: 20px;
            -moz-box-shadow: 0px 0px 16px #333333;
            -webkit-box-shadow: 0px 0px 16px #333333;
            box-shadow: 0px 0px 16px #333333;
            background-color: #fff;
        }

        .toptip {
            text-align: center;
            padding-top: 4px;
            height: 20px;
        }

        .invoiceHeader {
            height: 126px;
            display: flex;
            /* justify-content: space-between; */
            align-items: center;
        }

        .headerLeft {
            width: 300px;
            display: flex;
        }

        .headerLeft div:nth-child(1) {
            width: 85px;
            line-height: 26px;
        }

        .headerLeft div p {
            line-height: 26px;
        }

        .headerLeft div:nth-child(2) p.c-red {
            width: 170px;
            height: 46px;
            text-align: center;
            line-height: 42px;
            font-size: 24px;
            letter-spacing: 2px;
        }

        .headerLeft div p.c span {
            font-size: 18px;
            letter-spacing: 1px;
        }

        .headerRight {
            padding-left: 28px;
            width: 316px;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
        }

        .headerRight p {
            text-align: right;
            margin-top: -5px;
            padding: 5px 0;
        }

        .headerMiddle {
            text-align: center;
            width: 700px;
        }

        .headerMiddle h1 {
            font-size: 32px;
            color: #800000;
            padding-bottom: 8px;

        }

        .total .rmb {
            font-size: 16px;
        }

        .line {
            height: 2px;
            border-top: #800000 1px solid;
            border-bottom: #800000 1px solid;
            margin-bottom: 30px;
            width: 280px;
            position: relative;
            top: -28px;
        }

        .headerRight li {
            line-height: 24px;
        }

        .invoiceBody {
            border: 1px solid #800000;
        }

        .userInfo {
            width: 100%;
            display: flex;
            align-items: center;
            height: 96px;
            border-bottom: 1px solid #800000;
        }

        .userInfo ul {
            width: 100%;
            margin: 0 5px;
            padding: 0;
        }

        .userInfo ul li {
            line-height: 16px;
        }

        .userInfo ul li:nth-child(2) .f-big {
            padding-left: 24px;
            letter-spacing: 2px;
        }

        .userInfo ul li:nth-child(3) {
            position: relative;
        }

        .userInfo ul li .f-small2 {
            position: absolute;
            width: 120%;
            transform: scale(0.8);
            left: 44px;
        }

        .buy {
            width: 20px;
            border-right: 1px solid #800000;
            padding: 0 10px;
            text-align: center;
            height: 100%;
            display: flex;
            align-items: center;
            color: #800000;
            line-height: 20px;
            letter-spacing: 2px;
            writing-mode: vertical-rl;
            justify-content: center;
        }

        .vertical-rl {
            letter-spacing: 2px;
            writing-mode: vertical-rl;
            justify-content: center;
        }

        .password {
            width: 20px;
            padding: 0 10px;
            border-right: 1px solid #800000;
            border-left: 1px solid #800000;
            text-align: center;
            height: 100%;
            display: flex;
            align-items: center;
            color: #800000;
            line-height: 20px;
        }

        .pwdInfo {
            flex: 1;
            padding: 0 2px;
            height: 88px;
            overflow: hidden;
            word-break: break-all;
        }

        .goodsInfo {
            height: 210px;
            margin: 0;
            padding: 0;
        }

        .goodsInfo li {
            display: flex;
            color: #800000;
            text-align: center;
        }

        .name {
            width: 260px;
            border-right: 1px solid #800000;
        }

        .spec {
            width: 140px;
            border-right: 1px solid #800000;
        }

        .qty {
            width: 108px;
            border-right: 1px solid #800000;
        }

        .unit,
        .taxRate {
            width: 65px;
            border-right: 1px solid #800000;
        }

        .qty,
        .price {
            width: 160px;
            border-right: 1px solid #800000;
        }

        .money {
            flex: 1;
            border-right: 1px solid #800000;
        }

        .taxAmount {
            flex: 1;
        }

        .GoodsTable {
            height: 210px;
            width: 100%;
            border-collapse: collapse;
            table-layout: fixed
        }

        .GoodsTable td {
            color: #800000;
            padding: 0 4px;
        }

        .invoice-list td {
            color: #000;
            vertical-align: middle;
        }

        .invoice-list td:nth-child(5),
        .invoice-list td:nth-child(6),
        .invoice-list td:nth-child(7),
        .invoice-list td:nth-child(8),
        .total td:nth-child(5),
        .total td:nth-child(6),
        .total td:nth-child(7),
        .total td:nth-child(8) {
            text-align: right;
        }

        .invoice-list {
            height: 126px;
            overflow: hidden;
        }

        .invoice-list tr td {
            height: 21px;
        }

        .GoodsTable thead tr {
            height: 24px;
            text-align: center;
        }

        .GoodsTotal {
            height: 34px;
            border-top: 1px solid #800000;
            border-bottom: 1px solid #800000;
        }

        .total td {
            color: #000;
        }

        .total td:nth-child(1) {
            text-align: center;
            color: #800000;
        }

        .total td:nth-child(6),
        .total td:nth-child(8) {
        }

        .invoicetFooter {
            padding-top: 2px;
            display: flex;
            justify-content: space-between;
        }

        .invoicetFooter li {
            width: 25%;
        }

        .invoiceHeader-left {
            width: 67%;
            display: flex;
            align-items: center;
            justify-content: space-between;
        }

        .QRCodeBox {
            width: 83px;
            height: 83px;
            border: 1px solid #800000;
        }

        .flex-column-center {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }

        .flex-center {
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .QRCodeBox span {
            font-family: cursive;
            font-size: 22px;
            color: #800000;
            text-align: center;
        }

        .fontFamilyAuto , .fontFamilyAuto span, .fontFamilyAuto td{
            font-family: auto !important;
        }
        .text-c{
            text-align: center !important;
        }
        .headUl{
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            height: 100%;
        }
</style>